const BigNumber = require('bignumber.js');
const { populate } = require('@/functions/objects');
const { toFloat, toInt, toNullableInt, toNullableString } = require('@/functions/transform');

class TaxSummaryGroup {
    constructor(data = {}) {
        this.type = null;
        this.taxRate = 0.00;
        this.taxTypeID = null;
        this.taxTypeName = null;
        this.taxRegistrationCode = null;
        this.qty = 0;
        this.net = 0.00;
        this.tax = 0.00;
        this.gross = 0.00;

        /**
         * A letter gets assigned when tax is applied to the order.
         *
         * @type {string|null}
         */
        this.letter = null;

        populate(this, data);
    }

    getHydrationMap() {
        return {
            type: toNullableString,
            taxRate: toFloat,
            taxTypeID: toNullableInt,
            taxTypeName: toNullableString,
            taxRegistrationCode: toNullableString,
            qty: toInt,
            net: toFloat,
            tax: toFloat,
            gross: toFloat,
        };
    }

    /**
     * @return {number}
     */
    getTaxRateAsPercent() {
        return new BigNumber(this.taxRate).multipliedBy(100).toNumber();
    }

    /**
     * Add another group to this group's totals.
     *
     * @param {TaxSummaryGroup} group
     */
    addGroup(group) {
        this.qty = new BigNumber(this.qty).plus(group.qty).toNumber();
        this.net = new BigNumber(this.net).plus(group.net).toNumber();
        this.tax = new BigNumber(this.tax).plus(group.tax).toNumber();
        this.gross = new BigNumber(this.gross).plus(group.gross).toNumber();
    }
}

module.exports = TaxSummaryGroup;
